import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Flex,
  Text,
  useColorModeValue,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useToast,
} from "@chakra-ui/react";
import { RepeatIcon } from "@chakra-ui/icons";
import Card from "components/Card/Card.js";
import { activityLogsService } from "api";

export default function OTP() {
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const tableRowColor = useColorModeValue("#F7FAFC", "navy.900");
  const textTableColor = useColorModeValue("gray.500", "white");
  
  const [activityLogs, setActivityLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  const toast = useToast();

  // Fetch activity logs on component mount
  useEffect(() => {
    fetchActivityLogs();
  }, []);

  const fetchActivityLogs = async () => {
    setIsLoading(true);
    try {
      const response = await activityLogsService.getActivityLogs();
      console.log('Activity Logs API response:', response);
      if (response.success) {
        // Handle nested data structure: response.data.data contains the array
        const logsData = response.data?.data || [];
        console.log('Activity logs data:', logsData);
        setActivityLogs(Array.isArray(logsData) ? logsData : []);
      } else {
        toast({
          title: "خطأ",
          description: response.message || "حدث خطأ أثناء جلب سجلات النشاط",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        setActivityLogs([]);
      }
    } catch (error) {
      console.error('Error fetching activity logs:', error);
      toast({
        title: "خطأ",
        description: "حدث خطأ أثناء جلب سجلات النشاط",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      setActivityLogs([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Format date to human readable format
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      // Check if date is valid
      if (isNaN(date.getTime())) {
        return dateString;
      }
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      };
      return new Intl.DateTimeFormat('ar-UE', options).format(date);
    } catch (error) {
      console.error('Error formatting date:', error);
      return dateString;
    }
  };

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <Flex direction="column">
          <Flex px="25px" justify="space-between" mb="20px" align="center">
            <Text fontSize="22px" fontWeight="700" lineHeight="100%">
              سجلات OTP
            </Text>
            <Button
              variant="outline"
              onClick={fetchActivityLogs}
              isLoading={isLoading}
              minW="120px"
              leftIcon={<RepeatIcon />}
            >
              تحديث
            </Button>
          </Flex>

          {/* Activity Logs Table */}
          <Box overflowX="auto" px="25px" pb="25px">
            {isLoading ? (
              <Flex justify="center" align="center" py="40px">
                <Text color="gray.500">جاري تحميل السجلات...</Text>
              </Flex>
            ) : activityLogs.length === 0 ? (
              <Flex justify="center" align="center" py="40px">
                <Text color="gray.500">لا توجد سجلات متاحة</Text>
              </Flex>
            ) : (
              <Table variant="simple">
                <Thead>
                  <Tr bg={tableRowColor}>
                    <Th color="gray.400" borderColor={borderColor} textAlign="center">
                      رقم الهاتف
                    </Th>
                    <Th color="gray.400" borderColor={borderColor} textAlign="center">
                      OTP
                    </Th>
                    <Th color="gray.400" borderColor={borderColor} textAlign="center">
                      تاريخ الإنشاء
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {activityLogs.map((log, index) => (
                    <Tr key={index}>
                      <Td
                        color={textTableColor}
                        fontSize="sm"
                        fontWeight="bold"
                        borderColor={borderColor}
                        textAlign="center"
                      >
                        {log.phone || '-'}
                      </Td>
                      <Td
                        color={textTableColor}
                        fontSize="sm"
                        borderColor={borderColor}
                        textAlign="center"
                        fontFamily="mono"
                      >
                        {log.otp || '-'}
                      </Td>
                      <Td
                        color={textTableColor}
                        fontSize="sm"
                        borderColor={borderColor}
                        textAlign="center"
                      >
                        {formatDate(log.created_at)}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            )}
          </Box>
        </Flex>
      </Card>
    </Flex>
  );
}

